export const CALENDAR_INPUT_LENGTH = 10;

export const generateMonthSpan = (date: Date) => ({
  startDate: new Date(date.getFullYear(), date.getMonth(), 1),
  endDate: new Date(date.getFullYear(), date.getMonth() + 1, 0),
});
